package playground.gradient.ui

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.shadow
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.platform.LocalClipboardManager
import androidx.compose.ui.text.buildAnnotatedString
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import playground.gradient.data.ColorStop
import playground.gradient.data.Gradient

@Composable
internal fun CopyGradientCodeButton(
    gradient: Gradient,
    stops: List<ColorStop>,
    start: Offset,
    end: Offset,
    center: Offset,
) {
    val clipboardManager = LocalClipboardManager.current
    Box(
        modifier = Modifier
            .shadow(
                elevation = 10.dp,
                shape = CircleShape
            )
            .clip(CircleShape)
            .background(
                color = Color.White,
                shape = CircleShape,
            )
            .pointerHoverIcon(PointerIcon.Hand)
            .clickable {
                clipboardManager.setText(
                    buildAnnotatedString {
                        this.append(
                            when (gradient) {
                                Gradient.Linear -> generateLinearGradientCode(
                                    colorStops = stops,
                                    start = start, end = end
                                )

                                Gradient.Radial -> generateRadialGradientCode(
                                    colorStops = stops,
                                    center = center,
                                    radius = 1f,
                                )

                                Gradient.Sweep -> generateSweepGradientCode(
                                    colorStops = stops,
                                    center = center,
                                )
                            }

                        )
                    }
                )
            }
            .padding(horizontal = 28.dp, vertical = 12.dp)
    ) {
        Text(
            "Copy code",
            fontWeight = FontWeight.SemiBold,
            color = Color(0xff1c1c1c)
        )
    }
}